import { Metrics } from '@cognite/metrics';
import type { Language } from '@cognite/user-profile-components';

/**
 * Mixpanel super-property key. Registering it once attaches the active language
 * to every subsequent tracked event so all analytics can be segmented by locale.
 */
export const INFIELD_LANGUAGE_CODE_METRICS_PROPERTY = 'languageCode';
export const INFIELD_LANGUAGE_LABEL_METRICS_PROPERTY = 'languageLabel';

export const registerInfieldLanguageInMetrics = (language: Language): void => {
  Metrics.register({
    [INFIELD_LANGUAGE_CODE_METRICS_PROPERTY]: language.code,
    [INFIELD_LANGUAGE_LABEL_METRICS_PROPERTY]: language.label,
  });
};
